VjsAdmin.Organizations = (function () {
    const $table = $('#organizations-table');

    const init = function () {
        initTable();
    };

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#organizations-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No organizations ${typeof searchTerm !== 'undefined' ? ` matching search term \`${SafeDOM.escapeHtml(searchTerm)}\`` : ''}`;
            },
            idField: 'organization_id',
            sortName: 'organization_name',
            sortOrder: 'ASC',
            url: Slim.Router.pathFor('organizations.list.json'),
            columns: [
                {
                    title: 'Name',
                    field: 'organization_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'ID',
                    field: 'organization_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Salesforce Acct Id',
                    field: 'salesforce_account_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter: (value) => (!value
                        ? value
                        : `<a href="https://pathful.lightning.force.com/lightning/r/Account/${value}/view" target="_blank">${value}</a>`),
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                    field: 'date_modified',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.is_active = row.active;

                    if (VjsAdmin.hasPermission('organizations.edit.view')) {
                        const organizationEditUrl = Slim.Router.pathFor('organizations.edit.view', {
                            organization_id: row.organization_id,
                        });
                        row.actions = `<a href="${organizationEditUrl}" 
                            class="btn btn-hollow-blue" id="edit_organization_${row.organization_id}">Edit</a>`;
                    }

                    if (VjsAdmin.hasPermission('organizations.view')) {
                        const organizationViewUrl = Slim.Router.pathFor('organizations.view', { organization_id: row.organization_id });
                        row.organization_name = `<a href="${organizationViewUrl}" class="btn btn-hollow-blue"
                            id="view_organization_${row.organization_id}">${row.organization_name}</a>`;
                    }
                });
                return formattedResult;
            },
        });
    };

    return {
        init,
    };
}());
